/**
 * Standard layout spacing constants for consistent padding/margins across the app.
 * Based on MUI's spacing function (1 unit = 8px by default)
 */
export const LAYOUT_SPACING = {
  /** Page-level horizontal padding: 40px (5 * 8) */
  PAGE_HORIZONTAL: 5,

  /** Page-level vertical padding: 16px (2 * 8) */
  PAGE_VERTICAL: 2,

  /** Section spacing: 24px (3 * 8) */
  SECTION: 3,

  /** Card/component padding: 16px (2 * 8) */
  COMPONENT: 2,

  /** Tight spacing: 8px (1 * 8) */
  TIGHT: 1,
} as const;

/**
 * Standard tab spacing constants
 */
export const TAB_SPACING = {
  /** Tab-level top padding: 20px (2.5 * 8) */
  PADDING_TOP: 2.5,
} as const;

/**
 * Standard border radius values for consistent rounded corners.
 * Values in pixels for direct use in sx prop.
 */
export const BORDER_RADIUS = {
  /** Small radius for buttons, chips, small cards: 4px */
  SMALL: 1,

  /** Medium radius for cards, inputs, modals: 8px */
  MEDIUM: 2,

  /** Large radius for major containers, panels: 12px */
  LARGE: 3,

  /** Extra large radius for special emphasis: 16px */
  XL: 4,

  /** Full circle/pill shape */
  FULL: "50%",
} as const;
